module.exports = __webpack_public_path__ + "static/media/Sharp-Product-R-IGZO-Displays.63c654d4.jpg";